import useFeature from "hooks/useFeature";
import { AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG } from "ai-management/Constants";
import useAgentWorkflowsLicensed from "aiagent/hooks/useAgentWorkflowsLicensed";
const useShowAgentWorkflowUsage = () => {
  const isLicensed = useAgentWorkflowsLicensed();
  const multiModelEnabled = useFeature(AI_MULTI_MODEL_PROVIDER_FEATURE_FLAG);
  return isLicensed && !multiModelEnabled;
};
export default useShowAgentWorkflowUsage;
